import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Origins = /*#__PURE__*/function (Origins) {
  Origins[Origins["ORIGINS_UNSPECIFIED"] = 0] = "ORIGINS_UNSPECIFIED";
  Origins[Origins["ORIGINS_COMMUNITY_WP"] = 1] = "ORIGINS_COMMUNITY_WP";
  Origins[Origins["ORIGINS_ACADEMY_WP"] = 2] = "ORIGINS_ACADEMY_WP";
  Origins[Origins["ORIGINS_RESOURCE_CENTER_ZENDESK"] = 3] = "ORIGINS_RESOURCE_CENTER_ZENDESK";
  Origins[Origins["ORIGINS_VIDEO_WP"] = 4] = "ORIGINS_VIDEO_WP";
  Origins[Origins["ORIGINS_BP_MEMBERS_WP"] = 5] = "ORIGINS_BP_MEMBERS_WP";
  Origins[Origins["ORIGINS_ACADEMY_LESSON_WP"] = 6] = "ORIGINS_ACADEMY_LESSON_WP";
  Origins[Origins["ORIGINS_BP_GROUP_WP"] = 7] = "ORIGINS_BP_GROUP_WP";
  Origins[Origins["ORIGINS_PODCASTS_WP"] = 8] = "ORIGINS_PODCASTS_WP";
  Origins[Origins["ORIGINS_OPEN_API"] = 9] = "ORIGINS_OPEN_API";
  Origins[Origins["ORIGINS_COMMUNITY_POST_ZENDESK"] = 10] = "ORIGINS_COMMUNITY_POST_ZENDESK";
  return Origins;
}(Origins || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArticleStub {
  static fromProto(proto) {
    let m = new ArticleStub();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.thumbnail !== 'undefined') {
      toReturn['thumbnail'] = this.thumbnail;
    }
    return toReturn;
  }
}
class FilterParams {
  static fromProto(proto) {
    let m = new FilterParams();
    m = Object.assign(m, proto);
    if (proto.origins) {
      m.origins = proto.origins.map(v => enumStringToValue$2(Origins, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SearchArticleRequest {
  static fromProto(proto) {
    let m = new SearchArticleRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FilterParams.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchArticleResponse {
  static fromProto(proto) {
    let m = new SearchArticleResponse();
    m = Object.assign(m, proto);
    if (proto.articles) {
      m.articles = proto.articles.map(ArticleStub.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.articles !== 'undefined' && this.articles !== null) {
      toReturn['articles'] = 'toApiJson' in this.articles ? this.articles.toApiJson() : this.articles;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArticleHiddenToggleRequest {
  static fromProto(proto) {
    let m = new ArticleHiddenToggleRequest();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = enumStringToValue$1(Origins, proto.origin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.articleId !== 'undefined') {
      toReturn['articleId'] = this.articleId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Article {
  static fromProto(proto) {
    let m = new Article();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = enumStringToValue(Origins, proto.origin);
    }
    if (proto.sourceModified) {
      m.sourceModified = new Date(proto.sourceModified);
    }
    if (proto.voteCount) {
      m.voteCount = parseInt(proto.voteCount, 10);
    }
    if (proto.voteSum) {
      m.voteSum = parseInt(proto.voteSum, 10);
    }
    if (proto.replyCount) {
      m.replyCount = parseInt(proto.replyCount, 10);
    }
    if (proto.viewCount) {
      m.viewCount = parseInt(proto.viewCount, 10);
    }
    if (proto.answerCount) {
      m.answerCount = parseInt(proto.answerCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.articleId !== 'undefined') {
      toReturn['articleId'] = this.articleId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.sourceModified !== 'undefined' && this.sourceModified !== null) {
      toReturn['sourceModified'] = 'toApiJson' in this.sourceModified ? this.sourceModified.toApiJson() : this.sourceModified;
    }
    if (typeof this.voteCount !== 'undefined') {
      toReturn['voteCount'] = this.voteCount;
    }
    if (typeof this.voteSum !== 'undefined') {
      toReturn['voteSum'] = this.voteSum;
    }
    if (typeof this.promoted !== 'undefined') {
      toReturn['promoted'] = this.promoted;
    }
    if (typeof this.replyCount !== 'undefined') {
      toReturn['replyCount'] = this.replyCount;
    }
    if (typeof this.viewCount !== 'undefined') {
      toReturn['viewCount'] = this.viewCount;
    }
    if (typeof this.solved !== 'undefined') {
      toReturn['solved'] = this.solved;
    }
    if (typeof this.answerCount !== 'undefined') {
      toReturn['answerCount'] = this.answerCount;
    }
    if (typeof this.thumnailLinkUrl !== 'undefined') {
      toReturn['thumnailLinkUrl'] = this.thumnailLinkUrl;
    }
    return toReturn;
  }
}
class DeleteArticleRequest {
  static fromProto(proto) {
    let m = new DeleteArticleRequest();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = enumStringToValue(Origins, proto.origin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.articleId !== 'undefined') {
      toReturn['articleId'] = this.articleId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class DirectIndexArticleRequest {
  static fromProto(proto) {
    let m = new DirectIndexArticleRequest();
    m = Object.assign(m, proto);
    if (proto.article) {
      m.article = Article.fromProto(proto.article);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.article !== 'undefined' && this.article !== null) {
      toReturn['article'] = 'toApiJson' in this.article ? this.article.toApiJson() : this.article;
    }
    return toReturn;
  }
}
class IndexArticleRequest {
  static fromProto(proto) {
    let m = new IndexArticleRequest();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = enumStringToValue(Origins, proto.origin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.articleId !== 'undefined') {
      toReturn['articleId'] = this.articleId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

class PagedResponse {
  constructor(results, nextCursor, hasMore, totalResults) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
    this.totalResults = totalResults;
  }
}
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'help-center-api.vendasta-local.com',
  'test': '',
  'demo': 'help-center-demo.apigateway.co',
  'prod': 'help-center-prod.apigateway.co',
  'production': 'help-center-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let HelpCenterApiService = /*#__PURE__*/(() => {
  class HelpCenterApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    searchArticle(r) {
      const request = r.toApiJson ? r : new SearchArticleRequest(r);
      return this.http.post(this._host + "/helpcenter.v1.HelpCenter/SearchArticle", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchArticleResponse.fromProto(resp)));
    }
    indexArticle(r) {
      const request = r.toApiJson ? r : new IndexArticleRequest(r);
      return this.http.post(this._host + "/helpcenter.v1.HelpCenter/IndexArticle", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    directIndexArticle(r) {
      const request = r.toApiJson ? r : new DirectIndexArticleRequest(r);
      return this.http.post(this._host + "/helpcenter.v1.HelpCenter/DirectIndexArticle", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteArticle(r) {
      const request = r.toApiJson ? r : new DeleteArticleRequest(r);
      return this.http.post(this._host + "/helpcenter.v1.HelpCenter/DeleteArticle", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  HelpCenterApiService.ɵfac = function HelpCenterApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HelpCenterApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  HelpCenterApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HelpCenterApiService,
    factory: HelpCenterApiService.ɵfac,
    providedIn: 'root'
  });
  return HelpCenterApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HelpCenterService = /*#__PURE__*/(() => {
  class HelpCenterService {
    constructor(api) {
      this.api = api;
    }
    search(searchTerm, locale, filters, cursor, pageSize) {
      return this.api.searchArticle({
        searchTerm: searchTerm,
        locale: locale,
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => new PagedResponse(resp.articles, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults)));
    }
  }
  HelpCenterService.ɵfac = function HelpCenterService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HelpCenterService)(i0.ɵɵinject(HelpCenterApiService));
  };
  HelpCenterService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HelpCenterService,
    factory: HelpCenterService.ɵfac,
    providedIn: 'root'
  });
  return HelpCenterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ArticleHiddenToggleRequest, ArticleStub, DeleteArticleRequest, FilterParams, HelpCenterService, IndexArticleRequest, Origins, PagedResponse, SearchArticleRequest, SearchArticleResponse };
